import { ReportDB } from '../db';
// Report

class Report {
  API;

  constructor(API) {
    this.API = API;
  }

  get(id) {
    if (id) {
      return this.API.get(id);
    }
    return this.API.getAll();
  }

  create(data) {
    const newData = { id: Date.now(), ...data };
    return this.API.add(newData);
  }
}
const reportAPI = new Report(ReportDB);
export default reportAPI;
